import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export const url = '/libraries/management/types/country/entries'

@Injectable()
export class CountryService {
    constructor(private http: HttpService) {}
    getAll(): Observable<LibraryModel[]> {
        return this.http.get<LibraryModel[]>(url)
    }
}
